import React from "react";

const Loader = () => {
  return (
    <div
      className="flex min-h-dvh items-center justify-center bg-gray-50"
      role="status"
      aria-live="polite"
    >
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-amber-100 border-t-amber-600 motion-reduce:animate-none" />
      <span className="sr-only">Loading…</span>
    </div>
  );
};

export default Loader;
